<template>
  <div>
    <section class="orep-header mont" v-if="['group-appraiser-representation'].indexOf($route.name) < 0">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'Mercer'"  src="../../../public/assets/images/mercer-logo.png" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'Realshield'"  src="../../../public/assets/images/realshield-logo-blue.png" class="logo" alt="Logo">
        <img v-else  src="../../../public/assets/images/ibdpro-logo.svg" class="logo-ibdpro" alt="Logo">
        <span class="logo-text text-uppercase"></span>
      </section>
    </section>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "ibdpro-insurance-agent-application",
    computed: {
      insuranceAgentApplication() {
        return this.$store.state.insuranceAgentApplication.insuranceAgentApplication;
      },
      state() {
        return this.$store.state.insuranceAgentApplication;
      },
      errorMsg() {
        return this.$store.state.insuranceAgentApplication.errorMsg;
      },
      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/ibdpro-insurance-agent-application-amba/' || this.insuranceAgentApplication.customer.partnerName === 'Mercer'){
          return 'Mercer';
        }else if (first === '/portal/ibdpro-insurance-agent-application-realshield/' || this.insuranceAgentApplication.customer.partnerName === 'Realshield'){
          return 'Realshield';
        }else {
          return 'OREP';
        }
      },
    },
    data() {
      return {
        isActive: false,
      };
    },
    methods: {
      hamSpin() {
        this.isActive = !this.isActive;
      }
    }
  }
</script>
